import React from 'react';
import {
  Image, Text, TouchableOpacity, View,
} from 'react-native';
import Colors from '../../constants/Colors';
import { getInitials } from '../../screens/Tickets/components/TicketAssigneeIcon';
import CheckBox from '../16pxIcons/CheckBox';

export default function GroupUserRowMobile(props) {
  const generateColor = (length) => {
    const randomColor = Math.floor((1 / length) * 16777215)
      .toString(16)
      .padStart(6, '0');
    return `#${randomColor}`;
  };

  const getRoleTitle = (): string => {
    if (props.roleList?.length) {
      return props.roleList[0].name;
    }
    return props.isAdmin ? 'Admin' : 'Non Admin';
  };

  const renderUserIcon = () => {
    const imageSize = 32;
    if (props.icon === undefined) {
      return (
        <View
          style={{
            width: 56,
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <View
            style={{
              width: imageSize,
              height: imageSize,
              borderRadius: imageSize / 2,
              backgroundColor: generateColor(props.email.length),
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <Text
              style={{
                color: '#fff',
                fontFamily: 'Roboto_400Regular',
                fontSize: 8,
              }}
            >
              {getInitials(props.name)}
            </Text>
          </View>
        </View>
      );
    }
    return (
      <View
        style={{
          width: 56,
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <View
          style={{
            width: imageSize + 4,
            height: imageSize + 4,
            backgroundColor: props.selected ? '#fff' : 'transparent',
            borderColor: props.selected ? Colors.light.hereworksBlue500 : 'transparent',
            justifyContent: 'center',
            alignItems: 'center',
            borderRadius: (imageSize + 4) / 2,
          }}
        >
          <Image
            style={{
              width: imageSize,
              height: imageSize,
              borderRadius: imageSize / 2,
              overflow: 'hidden',
            }}
            source={{
              uri: props.icon,
            }}
          />
        </View>
      </View>
    );
  };

  return (
    <TouchableOpacity
      style={{
        flex: 1,
        borderRadius: 10,
        marginRight: 10,
        marginVertical: 3,
        paddingLeft: 12,
        paddingVertical: 8,
        flexDirection: 'row',
        alignItems: 'center',
        backgroundColor: props.selected
          ? Colors.light.hereworksWhite100 : '#fff',
        borderWidth: 1,
        borderColor: props.selected ? Colors.light.hereworksBlue500 : Colors.light.hereworksBlue100,
      }}
      onPress={() => {
        props.setSelected(!props.selected);
      }}
      testID={props.selected ? 'remove-user-from-user-group-btn' : 'add-user-to-user-group-btn'}
    >
      <CheckBox checkcolor={props.selected ? Colors.light.hereworksBlue500 : 'transparent'} />
      {renderUserIcon()}
      <View style={{ marginVertical: 15, flex: 1 }}>
        <Text
          style={{
            color: props.selected ? '#000' : Colors.light.hereworksBlack600,
            fontFamily: 'Poppins_600SemiBold',
            fontSize: 12,
            marginLeft: 4,
          }}
        >
          {props.name.trim().length === 0 ? props.email : props.name}
        </Text>
      </View>
      <Text style={{
        marginRight: 16,
        color: props.selected ? Colors.light.hereworksBlue500 : Colors.light.hereworksBlack400,
        fontFamily: 'Poppins_400Regular',
        fontSize: 12,
        backgroundColor: Colors.light.hereworksBlue50,
        paddingHorizontal: 8,
        paddingVertical: 4,
        borderRadius: 8,
      }}
      >
        {getRoleTitle()}
      </Text>
    </TouchableOpacity>
  );
}
